import { FilasModalS2S3Component } from '@components/calendar/modal-day/filas-modal-s2-s3/filas-modal-s2-s3.component';
import { ImputationS2S3Component } from '@components/calendar/modal-day/imputation-s2-s3/imputation-s2-s3.component';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { NotAuthorizedInterceptor } from './interceptors/not-authorized.interceptor';

import { DatePipe, TitleCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en-GB';
import localeES from '@angular/common/locales/es';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ChartsModule } from 'ng2-charts';
import { AppRoutingModule } from './app.routes';
import { LayoutModule } from './layout/layout.module';
import { PipesModule } from './pipes/pipes.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarService } from '@components/calendar/calendar.service';
import { ModalDayService } from '@components/calendar/modal-day/modal-day.service';
import { ModalWeekService } from '@components/calendar/modal-week/modal-week.service';
import { DsconfigService, RestConnService, LoadingService, ErrorService, ObservatoryService, StorageService, UserService, CookieService, AuthService } from './services/services.module';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ProjectsService } from '@services/projects/projects.service';
import { FileExporterService } from '@services/file-Exporter/file-exporter.service';
import { NotificationsService } from '@services/notifications/notifications.service';
import { AppComponent } from './app.component';
import { CalendarComponent } from '@components/calendar/calendar.component';
import { CalendarDayComponent } from '@components/calendar/calendar-day/calendar-day.component';
import { ResumenImputacionesComponent } from '@components/resumen-imputaciones/resumen-imputaciones.component';
import { ModalDayComponent } from '@components/calendar/modal-day/modal-day.component';
import { FilasModalComponent } from '@components/calendar/modal-day/filas-modal/filas-modal.component';
import { ModalWeekComponentRows } from '@components/calendar/modal-week/filas-modal-week/filas-modal-week.component';
import { ModalWeekComponent } from '@components/calendar/modal-week/modal-week.component';
import { DonutChartsComponent } from '@components/charts/donut-charts/donut-charts.component';
import { ResumenImputacionesGraficoComponent } from '@components/resumen-imputaciones-grafico/resumen-imputaciones-grafico.component';
import { NotificationsComponent } from '@components/notifications/notifications.component';
import { ServerComponent } from '@pages/error/server/server.component';
import { InternalComponent } from '@pages/error/internal/internal.component';
import { ProyectosComponent } from '@pages/admin/proyectos/gestion-proyectos/proyectos.component';
import { ReconocimientoProyectosComponent } from '@pages/admin/proyectos/reconocimiento-proyectos/reconocimiento-proyectos.component';
import { FormClientsComponent } from '@pages/admin/clientes/gestion-cliente/formulario-cliente/form-clients.component';
import { GestionCliComponent } from '@pages/admin/clientes/gestion-cliente/gestion-cli.component';
import { GestionCalendariosComponent } from '@app/pages/admin/calendarios/gestion-calendario/gestion-calendarios.component';
import { GestionEmpleadosComponent } from '@pages/admin/empleados/gestion-empleados/gestion-empleados.component';
import { TimeRecordingComponent } from '@pages/time-recording/time-recording.component';
import { HomeComponent } from '@pages/home/home.component';
import { LoginComponent } from '@pages/login/login.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

const MATERIALANGULAR = [
  MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatStepperModule, MatDatepickerModule, MatDialogModule,
  MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule,
  MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule,
  MatTooltipModule, MatTreeModule, DragDropModule
];

import {
  MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule,
  MatButtonModule, MatButtonToggleModule, MatCardModule,
  MatCheckboxModule, MatChipsModule, MatDatepickerModule,
  MatDialogModule, MatDividerModule, MatExpansionModule,
  MatGridListModule, MatIconModule, MatInputModule,
  MatListModule, MatMenuModule, MatNativeDateModule,
  MatPaginatorModule, MatProgressBarModule,
  MatProgressSpinnerModule, MatRadioModule, MatRippleModule,
  MatSelectModule, MatSidenavModule, MatSliderModule,
  MatSlideToggleModule, MatSnackBarModule, MatSortModule,
  MatStepperModule, MatTableModule, MatTabsModule,
  MatToolbarModule, MatTooltipModule, MatTreeModule
} from '@angular/material';
import { ResumenImputacionesService } from '@components/resumen-imputaciones/resumen-imputaciones.service';
import { CalendariosBloqueoComponent } from '@pages/admin/calendarios/calendarios-bloqueo/calendarios-bloqueo.component';
import { RangeCalendarComponent } from '@components/range-calendar/range-calendar.component';
import { LanguageControlComponent } from '@components/language-control/language-control.component';
import { PopupCalendarComponent } from '@components/popup-calendar/popup-calendar.component';
import { ExportacionComponent } from '@pages/admin/exportacion/exportacion.component';
import { GenericModalComponent } from '@components/generic-modal/generic-modal.component';
import { GestionEmpleadosImputacionComponent } from '@pages/admin/empleados/gestion-empleados-imputacion/gestion-empleados-imputacion.component';
import { FormularioEmpleadoComponent } from '@pages/admin/empleados/gestion-empleados/formulario-empleado/formulario-empleado.component';
import { DistribuidoraComponent } from '@pages/admin/distribuidora/distribuidora.component';
import { SearchInputDynamicComponent } from '@components/search-input-dynamic/search-input-dynamic.component';
import { LoaderViewComponent } from '@components/modal-loader/loader-view/loader-view.component';
import { contactsComponent } from '@pages/admin/contactos/contactos.component';
import { ContactsService } from '@pages/admin/contactos/contactos.service';
import { ExcelResumeComponent } from '@components/excel-resume/excel-resume.component';
import { TableComponent } from '@components/table/table.component';
import { SessionTimerComponent } from '@components/session-timer/session-timer.component';
import { DatePickerComponent } from '@components/date-picker/date-picker.component';
import { IgxTimePickerModule, IgxInputGroupModule, IgxIconModule } from 'igniteui-angular';
import { ImputationS1Component } from '@components/calendar/modal-day/imputation-s1/imputation-s1.component';
import { TimeControlComponent } from '@components/calendar/modal-day/time-control/time-control.component';
import { ModalMonthComponent } from '@components/calendar/modal-month/modal-month.component';
import { RangeCalendarManagementComponent } from './components/range-calendar-management/range-calendar-management.component';
import { DirectivesModule } from './directives/directives.module';
import { BreadCrumbsComponent } from './components/bread-crumbs/bread-crumbs.component';
import { SimpleInputComponent } from './components/simple-input/simple-input.component';
import { RecognitionModalComponent } from './pages/admin/proyectos/reconocimiento-proyectos/recognition-modal/recognition-modal.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { RecognitionService } from './services/recognition/recognition.service';
import { LoginManualComponent } from './pages/login-manual/login-manual.component';

registerLocaleData(localeES, 'es-ES');
registerLocaleData(localeEN, 'en-GB');
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    ProyectosComponent,
    ReconocimientoProyectosComponent,
    GestionEmpleadosComponent,
    FormClientsComponent,
    GestionCliComponent,
    GestionCalendariosComponent,
    CalendarComponent,
    CalendarDayComponent,
    ResumenImputacionesComponent,
    ModalDayComponent,
    FilasModalComponent,
    FilasModalS2S3Component,
    ModalWeekComponentRows,
    ModalWeekComponent,
    DonutChartsComponent,
    ResumenImputacionesGraficoComponent,
    NotificationsComponent,
    TimeRecordingComponent,
    ServerComponent,
    InternalComponent,
    HomeComponent,
    LoginComponent,
    LoginManualComponent,
    CalendariosBloqueoComponent,
    RangeCalendarComponent,
    LanguageControlComponent,
    PopupCalendarComponent,
    ExportacionComponent,
    GenericModalComponent,
    GestionEmpleadosImputacionComponent,
    DistribuidoraComponent,
    SearchInputDynamicComponent,
    LoaderViewComponent,
    FormularioEmpleadoComponent,
    contactsComponent,
    ExcelResumeComponent,
    TableComponent,
    SessionTimerComponent,
    DatePickerComponent,
    ImputationS1Component,
    ImputationS2S3Component,
    TimeControlComponent,
    ModalMonthComponent,
    RangeCalendarManagementComponent,
    BreadCrumbsComponent,
    SimpleInputComponent,
    RecognitionModalComponent,
    BackButtonComponent
  ],
  imports: [
    DirectivesModule,
    LayoutModule,
    ChartsModule,
    BrowserModule,
    AppRoutingModule,
    PipesModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...MATERIALANGULAR,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgbModule,
    IgxTimePickerModule,
    IgxInputGroupModule,
    IgxIconModule

  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    CalendarService,
    ResumenImputacionesService,
    ModalDayService,
    ModalWeekService,
    DsconfigService,
    RestConnService,
    LoadingService,
    ErrorService,
    ObservatoryService,
    UserService,
    CookieService,
    StorageService,
    ProjectsService,
    NotificationsService,
    TitleCasePipe,
    TranslateService,
    AuthService,
    FileExporterService,
    ContactsService,
    RecognitionService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NotAuthorizedInterceptor, multi: true },
    DatePipe
  ],

  entryComponents: [LoaderViewComponent, ModalDayComponent, ModalWeekComponent, SessionTimerComponent, ModalMonthComponent],
  bootstrap: [AppComponent],
  exports: [
    FormsModule,
    ReactiveFormsModule
  ]
})
export class AppModule {
  constructor(private rest: RestConnService) { }
}
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
